'use strict';

exports.__esModule = true;
exports.TaskStatusConnector = exports.TaskStatus = exports.TaskStatusItem = exports.styles = exports.locales = undefined;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _class, _temp, _class2, _temp2; // import {
//   taskStatusEnum,
// } from "../../../query";
// import { Typography } from 'material-ui';


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _materialUi = require('material-ui');

var _reactApollo = require('react-apollo');

var _component = require('@prisma-cms/component');

var _component2 = _interopRequireDefault(_component);

var _graphqlTag = require('graphql-tag');

var _graphqlTag2 = _interopRequireDefault(_graphqlTag);

var _context = require('@prisma-cms/context');

var _context2 = _interopRequireDefault(_context);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var locales = exports.locales = {
  ru: {
    values: {
      "Status": "Статус",
      "New": "Новая",
      "Accepted": "Принята",
      "Rejected": "Отменена",
      "Progress": "Выполняется",
      "Paused": "Приостановлена",
      "Done": "Выполнена",
      "Discuss": "Обсуждается",
      "Approved": "Одобрена",
      "RevisionsRequired": "Требуется проверка",
      "Completed": "Завершена"
    }
  }
};
var styles = exports.styles = {
  root: {},
  item: {
    cursor: "pointer"
  },
  status: {
    color: "#333",
    padding: 2
  },
  statusNew: {
    backgroundColor: "#aa8cb9"
  },
  statusAccepted: {
    backgroundColor: "#c7ecc5"
  },
  statusRejected: {
    backgroundColor: "lightgray"
  },
  statusProgress: {
    backgroundColor: "#92f78c"
  },
  statusPaused: {
    backgroundColor: "#afecec"
  },
  statusDone: {
    backgroundColor: "#4dfb43"
  },
  statusDiscuss: {
    backgroundColor: "#f7c78c"
  },
  statusApproved: {
    backgroundColor: "#0bdc0b"
  },
  statusRevisionsRequired: {
    backgroundColor: "#8ccbf5"
  },
  statusCompleted: {
    backgroundColor: "#05c305"
  }
};
var TaskStatusItem = exports.TaskStatusItem = (_temp = _class = function (_PrismaCmsComponent) {
  _inherits(TaskStatusItem, _PrismaCmsComponent);

  function TaskStatusItem() {
    _classCallCheck(this, TaskStatusItem);

    return _possibleConstructorReturn(this, _PrismaCmsComponent.apply(this, arguments));
  }

  TaskStatusItem.prototype.render = function render() {
    var _props = this.props,
        value = _props.value,
        classes = _props.classes;
    var content = null;

    if (value) {
      return _react2.default.createElement(_materialUi.Typography, {
        component: 'span',
        className: [classes.status, classes['status' + value]].join(" ")
      }, this.lexicon(value));
    }

    return content;
  };

  return TaskStatusItem;
}(_component2.default), _class.propTypes = _extends({}, _component2.default.propTypes, {
  inEditMode: _propTypes2.default.bool.isRequired,
  value: _propTypes2.default.string
}), _class.defaultProps = _extends({}, _component2.default.defaultProps, {
  inEditMode: false,
  locales: locales
}), _temp);
var TaskStatus = exports.TaskStatus = (0, _materialUi.withStyles)(styles)(function (props) {
  return _react2.default.createElement(TaskStatusItem, props);
}); // export const processors = compose(
//   graphql(taskStatusEnum),
//   // graphql(createTaskProcessor, {
//   //   name: "createTask",
//   // }),
//   // graphql(updateTaskProcessor, {
//   //   name: "updateTask",
//   // }),
// );
// export default processors(withStyles(styles)(props => <TaskStatus 
//   {...props}
// />));

var TaskStatusConnector = exports.TaskStatusConnector = (_temp2 = _class2 = function (_Component) {
  _inherits(TaskStatusConnector, _Component);

  function TaskStatusConnector() {
    _classCallCheck(this, TaskStatusConnector);

    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  TaskStatusConnector.prototype.componentWillMount = function componentWillMount() {
    var taskStatusEnum = this.context.query.taskStatusEnum;
    var View = this.props.View;
    this.Renderer = (0, _reactApollo.graphql)((0, _graphqlTag2.default)(taskStatusEnum))(View);
    _Component.prototype.componentWillMount && _Component.prototype.componentWillMount.call(this);
  };

  TaskStatusConnector.prototype.render = function render() {
    var Renderer = this.Renderer;

    var _props2 = this.props,
        View = _props2.View,
        other = _objectWithoutProperties(_props2, ['View']);

    return _react2.default.createElement(Renderer, other);
  };

  return TaskStatusConnector;
}(_react.Component), _class2.contextType = _context2.default, _class2.defaultProps = {
  View: TaskStatusItem
}, _temp2);
TaskStatusConnector.propTypes = process.env.NODE_ENV !== "production" ? {
  View: _propTypes2.default.func.isRequired
} : {};
exports.default = (0, _materialUi.withStyles)(styles)(function (props) {
  return _react2.default.createElement(TaskStatusConnector, props);
});